<template>
  <div>
    <div class="fullWidthDivider"></div>
    <div class="drawerShowMore" :class="drawerClass">
      <div
        :class="isActive ? 'drawerShowMore-hd isActive' : 'drawerShowMore-hd'"
      >
        <div @click="drawerShowMoreHandler" class="showMoreDrawer-hd">
          <div class="drawerShowMoreTitle">{{ heading }}</div>
          <div class="drawer-hd-indicator">
            <span
              :class="
                isActive ? 'chevronIcon isOpened' : 'chevronIcon isClosed'
              "
              ><AccordionChevron :width="'20'" :height="'26'"
            /></span>
          </div>
        </div>
        <slot />
      </div>
      <div
        :class="
          !isActive ? 'drawerShowMore-fade isEnabled' : 'drawerShowMore-fade'
        "
      ></div>
      <div @click="drawerShowMoreHandler" class="showMoreShowLessContainer">
        <span class="drawerShowMore-trigger">
          {{ isActive ? "" : "SHOW MORE" }}
        </span>
        <span
          :class="isActive ? 'chevronIcon isOpened' : 'chevronIcon isClosed'"
        >
          <AccordionChevron v-if="!isActive" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import AccordionChevron from "../shared/AccordionChevron.vue";
export default {
  components: {
    AccordionChevron
  },
  props: {
    heading: String,
    drawerClass: String
  },
  data() {
    return {
      isActive: false
    };
  },
  methods: {
    drawerShowMoreHandler: function() {
      !this.isActive
        ? (this.isActive = !this.isActive)
        : (this.isActive = false);
    }
  }
};
</script>

<style lang="scss" scoped>
.fullWidthDivider {
  display: block;
  height: 1px;
  background: $lightgray;
  border-radius: 0px;
  width: 100%; /* vw fallback for ie*/
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;

  @include media-breakpoint-up(lg) {
    left: 57%;
    margin-left: -57vw;
  }
}
.showMoreDrawer-hd {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  margin-bottom: 20px;

  .drawer-hd-indicator {
    display: flex;
    align-items: center;
    padding-top: 20px;
  }
}
.drawerShowMoreTitle {
  color: rgb(38, 38, 38);
  width: fit-content;
  font-size: 26px;
  font-family: $heading;
  font-weight: 600;
  letter-spacing: 0px;
  line-height: 39px;
  text-align: left;
  border-bottom: 3px solid $secondary-300;
  padding-bottom: 5px;
  padding-top: 20px;
  @include media-breakpoint-up(lg) {
    font-size: 32px;
    line-height: 48px;
    letter-spacing: -0.1px;
  }
}
.drawerShowMore {
  margin-bottom: 30px;
}

.drawerShowMore-hd {
  margin-bottom: 15px;
  max-height: 334px;
  overflow: hidden;
  transition: max-height 0.2s ease-out;
}

.drawerShowMore-hd.isActive {
  max-height: 100%;
}
.showMoreShowLessContainer {
  display: flex;
  cursor: pointer;
  width: fit-content;

  @include media-breakpoint-up(lg) {
    &:hover {
      .drawerShowMore-trigger {
        color: #8193a0;
      }
      svg {
        opacity: 0.6;
      }
    }
  }
}

.chevronIcon {
  padding-left: 11px;
  padding-top: 2px;

  @include media-breakpoint-up(md) {
    padding-top: 0px;
  }
  @include media-breakpoint-up(lg) {
    padding-top: 5px;
  }
}
.chevronIcon.isOpened {
  svg {
    transform: rotate(180deg);
    -moz-transition: all 0.25s ease-in-out;
    -o-transition: all 0.25s ease-in-out;
    -webkit-transition: all 0.25s ease-in-out;
    transition: all 0.25s ease-in-out;
  }
}
.chevronIcon.isClosed {
  svg {
    -moz-transition: all 0.25s ease-in-out;
    -o-transition: all 0.25s ease-in-out;
    -webkit-transition: all 0.25s ease-in-out;
    transition: all 0.25s ease-in-out;
  }
}

.drawerShowMore-fade.isEnabled {
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 75%
  );
  height: 140px;
  margin-top: -100px;
  position: relative;
}

.drawerShowMore-trigger {
  display: block;
  font-size: 14px;
  text-align: left;
  color: $primary;
  font-family: $heading;
  font-weight: bold;
  letter-spacing: 0.4px;
  line-height: 21px;

  @include media-breakpoint-up(md) {
    font-size: 16px;
  }

  @include media-breakpoint-up(lg) {
    font-size: 18px;
    letter-spacing: 0.2px;
    line-height: 27px;
  }
}

.productDescription__drawerContainer {
  .drawerShowMore-fade.isEnabled {
    height: 90px;
  }
  .drawerShowMore-hd.isActive {
    margin-bottom: 0px;
  }
}
</style>
